"use client";
import { useSearchParams } from "next/navigation";
import { IBlogsCategory } from "@/api/AppApi/services/blogs/interfaces/IBlogs";
import CustomButton, {
  BtnRadius,
  BtnSizes,
  BtnTypes,
} from "@/app/components/lib/CustomButton";
import { Link } from "@/app/components/lib/navigation/Link";
import { PagesPaths } from "@/utils/functions/pages-paths";
import TabsSlider from "@/app/components/lib/Embla-tabs-slider/TabsSlider";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface Props {
  blogCategories: IBlogsCategory[];
}
const BlogCategories: React.FC<Props> = ({ blogCategories }) => {
  const statusQuery = "category";
  const searchParams = useSearchParams();
  const t = useTranslation();
  const allStatus = blogCategories;
  const statusTypes =
    [{ key: "null", value: t.all, blogs_count: 0 }, ...allStatus] ?? [];
  const selectedKey = searchParams?.get(statusQuery) ?? "null";
  const selectedIndex = statusTypes.findIndex((st) => st.key == selectedKey);
  return (
    <div style={{ width: "100%", maxWidth: "100%", overflow: "hidden" }}>
      <TabsSlider spacing={6} selectedIndex={selectedIndex}>
        {statusTypes.map((statusType) => (
          <Link
            prefetch={false}
            key={statusType.key}
            href={
              PagesPaths.blog +
              (statusType.key === "null"
                ? ""
                : `?${statusQuery}=${statusType.key}`)
            }
          >
            <CustomButton
              type={
                selectedKey === statusType.key
                  ? BtnTypes.primary
                  : BtnTypes.neutral
              }
              size={BtnSizes.option}
              radius={BtnRadius.large}
            >
              {statusType.value}
            </CustomButton>
          </Link>
        ))}
      </TabsSlider>
    </div>
  );
};

export default BlogCategories;
